// extracted by mini-css-extract-plugin
export default {"form":"UserTariffForm_form__-aAE2","text":"UserTariffForm_text__yiT6U","checkbox":"UserTariffForm_checkbox__SapZ0"};